import React, { useEffect, useRef, useState, useContext } from "react";
import constants from '../../Components/Services/constant';
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import Menu from "../Home/Menu";
import Services from "../Home/Services";
import Blogs from "../Home/Blogs";
import Resevation from "../Home/Reservation";
import Clients from "../Home/Clients";
import Testimonials from "../Home/Testimonials";
import { ApiService } from "../../Components/Services/apiservices";
import Modal from "react-bootstrap/Modal";
import DataContext from "../../Components/Elements/eventContext";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./styles.css";

let apiServices = new ApiService();

function Homepage2() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [faqData, setfaqData] = useState([]);
    const [videoData, setvideoData] = useState([]);

    const didMountRef = useRef(true);
    const contextValues = useContext(DataContext);


    const [pageData, setPageData] = useState({});

    // Fetch settings & site data
    useEffect(() => {
        if (didMountRef.current) {
            apiServices.settingsdataGetRequest()
                .then((res) => {
                    if (res.data.status === "success") {
                        contextValues.setImageUrl(res.data.settings_url);
                        contextValues.setSettingData(res.data.sitesettings);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching settings data:", err);
                });

            const dataString = { page_url: "home" };
            apiServices.pagePostRequest(dataString)
                .then((res) => {
                    if (res.data.status === "success" && res.data.pageData) {
                        setPageData(res.data.pageData);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching home page data:", err);
                });
        }
        didMountRef.current = false;
    }, [contextValues]);

    useEffect(() => {
        apiServices.getHomeFaqDataRequest()
            .then((res) => {
                if (res.data.status === "success") {
                    setfaqData(res.data.faqdata);
                }
            })
            .catch((err) => {
                console.error("Error fetching FAQ data:", err);
            });
    }, []);

    useEffect(() => {
        apiServices.getVideoDataRequest()
            .then((res) => {
                if (res.data.status === "success") {
                    setvideoData(res.data.videodata);
                }
            })
            .catch((err) => {
                console.error("Error fetching video data:", err);
            });
    }, []);

    const getEmbedUrl = (url) => {
        try {
            if (url.includes("youtu.be")) {
                const videoId = url.split("youtu.be/")[1].split("?")[0];
                return `https://www.youtube.com/embed/${videoId}`;
            }
            if (url.includes("/shorts/")) {
                const videoId = url.split("/shorts/")[1].split("?")[0];
                return `https://www.youtube.com/embed/${videoId}`;
            }
            if (url.includes("watch?v=")) {
                const videoId = url.split("watch?v=")[1].split("&")[0];
                return `https://www.youtube.com/embed/${videoId}`;
            }
            return url;
        } catch {
            return url;
        }
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className="homepage2-wrapper">
            <Header />
            <style>
            {`
                @media (max-width: 768px) {
                    .image-grid-container .story-slider-fullwidth {
                        padding: 0 !important;
                    }
                    .image-grid-container .row {
                        --bs-gutter-x: 0;
                    }
                    .image-grid-container img.img-fluid {
                        border-radius: 0 !important;
                    }
                }
            `}
            </style>
            {/* Hero Banner Section */}
            <header className="hero-gymkhana" style={{ 
                '--bg-desktop': `url('${pageData?.metadata?.hero_desktop_image ? `${constants.IMAGE_URL}${pageData.metadata.hero_desktop_image}` : "/assets/img/food/Banner2home.jpeg"}')`, 
                '--bg-mobile': `url('${pageData?.metadata?.hero_mobile_image ? `${constants.IMAGE_URL}${pageData.metadata.hero_mobile_image}` : "/assets/img/food/bannrm.jpeg"}')` 
            }}>
                <div className="hero-content">
                    { <h1 className="hero-subtitle" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.hero_subtitle || 'Experience Royal <br/>Indian Fine Dining' }} /> }

                </div>
            </header>

            {/* Our Story Section */}
            <section className="our-story-section text-center">
                <div className="container">
                    <div className="story-text-container-full mb-5">
                        <h2 className="story-title">{pageData?.metadata?.story_title || 'Our Story'}</h2>
                        <div className="story-divider mx-auto">
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                        </div>
                        <p className="story-description">
                            {pageData?.metadata?.story_description || 'Chokhi Dhani has championed local culture and hospitality in India for over 34 years. We bring this rich heritage to London, blending Royal Rajasthani Cuisine, a vibrant atmosphere, and exceptional service from the land of Maharajas.'}
                        </p>
                    </div>
                </div>

                <div className="container-fluid px-0 mb-5">
                    <div className="story-slider-fullwidth">
                        <picture>
                            <source media="(max-width: 768px)" srcSet={pageData?.metadata?.story_mobile_image ? `${constants.IMAGE_URL}${pageData.metadata.story_mobile_image}` : "/assets/img/food/OurStoryMobilehome.webp"} />
                            <img src={pageData?.metadata?.story_desktop_image ? `${constants.IMAGE_URL}${pageData.metadata.story_desktop_image}` : "/assets/img/food/OurStorydesktop.webp"} alt="Chokhi Dhani London dining room" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                        </picture>
                    </div>
                </div>

                <div className="container">
                    <a href="/about-us" className="btn-story-readmore">
                        Read More
                    </a>
                </div>
            </section>

            {/* Our Rajasthani Cuisine Section */}
            <section className="our-story-section text-center" style={{ paddingTop: '20px' }}>
                <div className="container">
                    <div className="story-text-container-full mb-5">
                        <h2 className="story-title">{pageData?.metadata?.cuisine_title || 'Rajasthani Cuisine'}</h2>
                        <div className="story-divider mx-auto">
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                        </div>
                        <p className="story-description">
                            {pageData?.metadata?.cuisine_description || 'We are proud to be the first to bring authentic Rajasthani cuisine to London, offering more than just a meal—an immersive journey into Rajasthan\'s rich culture, royal legacy, and warm hospitality. Every detail reflects the traditions and timeless spirit of this remarkable region.'}
                        </p>
                    </div>
                </div>

                <div className="container-fluid px-0 mb-2">
                    <div className="story-slider-fullwidth">
                        <picture>
                            <source media="(max-width: 768px)" srcSet={pageData?.metadata?.cuisine_mobile_image ? `${constants.IMAGE_URL}${pageData.metadata.cuisine_mobile_image}` : "/assets/img/food/OurRajasthaniCuisinemobile.webp"} />
                            <img src={pageData?.metadata?.cuisine_desktop_image ? `${constants.IMAGE_URL}${pageData.metadata.cuisine_desktop_image}` : "/assets/img/food/rajasthani_cuisine_img.jpeg"} alt="Authentic Rajasthani Thali" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                        </picture>
                    </div>
                </div>

                {/* New Image Grid Section */}
                <div className="image-grid-container" style={{ padding: '0 0 30px 0' }}>
                    <div className="story-slider-fullwidth">
                        <div className="row g-2">
                            <div className="col-12 col-md-6">
                                <img 
                                    src={pageData?.metadata?.grid_image_1 ? `${constants.IMAGE_URL}${pageData.metadata.grid_image_1}` : "/assets/img/food/home1.webp"} 
                                    alt="Luxurious Restaurant Interior" 
                                    className="img-fluid w-100" 
                                    style={{ objectFit: 'cover' }} 
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img 
                                    src={pageData?.metadata?.grid_image_2 ? `${constants.IMAGE_URL}${pageData.metadata.grid_image_2}` : "/assets/img/food/home3.webp"} 
                                    alt="Luxurious Restaurant Interior" 
                                    className="img-fluid w-100" 
                                    style={{ objectFit: 'cover' }} 
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img 
                                    src={pageData?.metadata?.grid_image_3 ? `${constants.IMAGE_URL}${pageData.metadata.grid_image_3}` : "/assets/img/food/home2.webp"} 
                                    alt="Elegant Cocktail" 
                                    className="img-fluid w-100" 
                                    style={{ objectFit: 'cover' }} 
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img 
                                    src={pageData?.metadata?.grid_image_4 ? `${constants.IMAGE_URL}${pageData.metadata.grid_image_4}` : "/assets/img/food/home4.webp"} 
                                    alt="Elegant Cocktail" 
                                    className="img-fluid w-100" 
                                    style={{ objectFit: 'cover' }} 
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <a href="/menu" className="btn-story-readmore">
                        Read More
                    </a>
                </div>
            </section>

            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Body className="login-modal-content">
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={handleClose}
                    ></button>
                </Modal.Body>
            </Modal>


            <Footer />
        </div>
    );
}

export default Homepage2;
